<template>
    <div>
        <div class="hred">
            <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
            <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
        </div>
        <div style="    font-weight: 700;
    font-style: normal;
    font-size: 36px;text-align: center;margin-top: 40px;">机构评分进度查询
        </div>
        <div style="margin-top: 20px;margin-bottom: 20px;">
            <img class="img " src="@/images/biaodan/u113.png">
        </div>
    </div>
    <!-- 表格 -->

    <div style="display: flex;margin-left: 30px;">
        <div class="kuang n1">机构名称</div>
        <div class="kuang n2">{{ this.form.orgName }}</div>
        <div class="kuang n3">法人姓名</div>
        <div class="kuang n4">
            {{ this.form.orgHeader }}
        </div>
    </div>
    <div style="display: flex;margin-left: 30px;">
        <div class="kuang n1">手机号码</div>
        <div class="kuang n2">{{ this.form.orgHeaderPhone }}</div>
        <div class="kuang n3">身份证号</div>
        <div class="kuang n4">
            {{ this.form.idcardNo }}
        </div>
    </div>
    <div style="display: flex;margin-left: 30px;">
        <div class="kuang n1">成立时间</div>
        <div class="kuang n2">{{ this.form.establishDate }}</div>
        <div class="kuang n3">所属地区</div>
        <div class="kuang n4">
            {{ this.form.are }}
        </div>
    </div>
    <div style="display: flex;margin-left: 30px;">
        <div class="kuang n1">自评得分</div>
        <div class="kuang n2">{{ this.form.selfScoreTotal }}</div>
        <div class="kuang n3">实际得分</div>
        <div class="kuang n4">{{ this.form.realScoreTotal }} </div>
    </div>
    <div style="display: flex;margin-left: 30px;">
        <div class="kuang n1">审核状态</div>
        <div class="kuang n2" style="color: red;font-weight: bold">{{ this.form.verifyMsg }}</div>
        <div class="kuang n3">星级</div>
        <div class="kuang n4">{{ this.form.starLevel }}</div>
    </div>
    <div style="display: flex;margin-left: 30px;" v-if="this.form.complainAuditStatus!=0">
        <div class="kuang n1">申诉状态</div>
        <div class="kuang n2" style="width: 790px;color: red;font-weight: bold">{{ this.form.complainAuditStatusMsg }}</div>
    </div>
    <div style="display: flex;height: 200px;margin-left: 30px;" v-if="this.form.complainAuditStatus==3">
        <div class="kuang n6" style="height: 198px">驳回原因</div>
        <div class="kuang n5" style=" height: auto;word-wrap:break-word;">
            {{ this.form.complainRefuseReason }}
        </div>
    </div>

    <el-button id="backIndex" style="cursor: pointer;position: relative;top:30px;" type="danger" size="medium"
               @click="toIndex">返回首页
    </el-button>
    <el-button id="update" style="cursor: pointer;position: relative;top:30px;" type="danger" size="medium"
               v-if="this.form.scoreAuditStatus == 1" @click="toupdate">修改自评分信息
    </el-button>
    <el-button id="query" style="cursor: pointer;position: relative;top:30px;" type="danger" size="medium"
               v-if="this.form.scoreAuditStatus == 2 || this.form.scoreAuditStatus == 3" @click="toupdate">查看自评分信息
    </el-button>
    <el-button id="complain" style="cursor: pointer;position: relative;top:30px;" type="danger" size="medium"
               v-if="this.form.scoreAuditStatus == 3 && this.form.complainAuditStatus == 0" @click="tocomplain">申诉评分
    </el-button>


    <!-- Unnamed (矩形) -->
    <div id="u58" class="ax_default label">
        <div id="u58_div" class=""></div>
        <div id="u58_text" class="text ">
            <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
            <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
            <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
        </div>
    </div>
</template>

<script>
import {getOrgScoreInfoWithNoPhoneCode} from '@/requst/api'
import {ElMessage} from "element-plus";
export default {
    name: 'BaoBei',
    data() {
        return {
            form: {
                orgName: '',
                orgHeader: '',
                orgHeaderPhone: '',
                idcardNo: '',
                establishDate: '',
                auditStatus: '',
                auditRemark: '',
                createTime: '',
                updateTime: '',
            },
        }
    },
    created() {
        let date = JSON.parse(localStorage.getItem('cxjg'))
        this.form.orgName = date.orgName
        this.form.orgHeader = date.orgHeader
        this.form.orgHeaderPhone = date.orgHeaderPhone
        this.form.idcardNo = date.idcardNo
        this.form.establishDate = date.establishDate
        this.form.selfScoreTotal = date.selfScoreTotal+"分"
        this.form.scoreAuditStatus = date.scoreAuditStatus;
        if(this.form.scoreAuditStatus == 3){
            this.form.realScoreTotal = date.realScoreTotal+"分"
            this.form.starLevel = date.auditStarLevel == '3' ? '三星' :(date.auditStarLevel == '4' ? '四星' :(date.auditStarLevel == '5' ? '五星' : '低于三星'))
           // this.form.starLevel = date.auditStarLevel == '1' ? '一星' :(date.auditStarLevel == '2' ? '二星' :(date.auditStarLevel == '3' ? '三星' :(date.auditStarLevel == '4' ? '四星' :'五星')))
        }else{
            this.form.realScoreTotal = '--'
            this.form.starLevel = '--'
            //this.form.starLevel = date.starLevel == '1' ? '一星' :(date.starLevel == '2' ? '二星' :(date.starLevel == '3' ? '三星' :(date.starLevel == '4' ? '四星' :'五星')))
        }


        this.form.auditStatus = date.auditStatus
        this.form.auditRemark = date.auditRemark

        this.form.complainAuditStatus = date.complainAuditStatus
        this.form.complainAuditStatusMsg = date.complainAuditStatus == '0' ? '未提交申诉' : (date.complainAuditStatus == '1' ? '申诉中' : (date.complainAuditStatus == '2' ? '申诉通过' : "申诉驳回"))
        this.form.complainRemark = date.complainRemark;
        this.form.complainRefuseReason = date.complainRefuseReason;
        this.form.createTime = date.createTime
        this.form.are = date.provinceName+" "+date.cityName+ " " + date.countyName
        this.form.updateTime = date.updateTime ? date.updateTime :"暂未受理"
        this.form.verifyMsg = date.scoreAuditStatus == '0' ? '未提交评分' : (date.scoreAuditStatus == '1' ? '待审核' : (date.scoreAuditStatus == '2' ? '审核中' : (date.scoreAuditStatus == '3' ? '已审核' : "审核中")))
        // this.form = JSON.parse(localStorage.getItem('jindu')) ? JSON.parse(localStorage.getItem('jindu')) : this.form
    },
    mounted() {
        if(this.form.scoreAuditStatus == 0 || this.form.scoreAuditStatus == 4 ){
            document.getElementById("backIndex").style.left = "47%";
        }
        //评分待审核
        if(this.form.scoreAuditStatus == 1){
            document.getElementById("backIndex").style.left = "30%";
            document.getElementById("update").style.left = "50%";
        }
        //评分审核中
        if(this.form.scoreAuditStatus == 2){
            document.getElementById("backIndex").style.left = "30%";
            document.getElementById("query").style.left = "50%";
        }
        //评分审核通过，未申诉
        if(this.form.scoreAuditStatus == 3 && this.form.complainAuditStatus == 0){
            document.getElementById("backIndex").style.left = "15%";
            document.getElementById("query").style.left = "35%";
            document.getElementById("complain").style.left = "55%";
        }
        //评分审核通过，已申诉
        if(this.form.scoreAuditStatus == 3 && this.form.complainAuditStatus != 0){
            document.getElementById("backIndex").style.left = "30%";
            document.getElementById("query").style.left = "50%";
        }
    },
    methods: {
        inputnow() {
           // localStorage.setItem('jindu', JSON.stringify(this.form))
        },
        toIndex() {
            this.$router.push('/')
        },
        toupdate() {
            this.form.realScoreTotal=null
            this.form.selfScoreTotal=null;
            getOrgScoreInfoWithNoPhoneCode(this.form).then(res=>{
                if(!res.data){
                    ElMessage.error(res.header.msg)
                }
                if(res.data){
                    localStorage.setItem('orgId',JSON.parse(res.data.orgInfo).id)
                    localStorage.setItem('form1',res.data.bxfx)
                    localStorage.setItem('form2',res.data.bxtj)
                    localStorage.setItem('form3',res.data.gfbx)
                    localStorage.setItem('form4',res.data.csqk)
                    localStorage.setItem('form5',res.data.rypz)
                    localStorage.setItem('form6',res.data.shxy)
                    localStorage.setItem("scoreAuditStatus",JSON.parse(res.data.orgInfo).scoreAuditStatus);
                    localStorage.setItem("type",1)
                    this.$router.push('/score')
                }
            })
        },
        tocomplain(){
            this.$router.push('/scoreComplain')
        }

    }
}
</script>
<style scoped>
.kuang {
    border: 0.1px solid #cccccc;
    border-width: thin;

}

.l1 {
    width: 400px;
    height: 50px;
    line-height: 50px;
    position: absolute;
    top: 272px;
    left: 240px;

}

.l2 {
    width: 400px;
    height: 50px;
    line-height: 50px;
    position: absolute;
    top: 312px;
    left: 240px;
}

.l3 {
    width: 400px;
    height: 50px;
    line-height: 50px;
    position: absolute;
    top: 352px;
    left: 240px;
}

.l4 {
    width: 400px;
    height: 50px;
    position: absolute;
    top: 392px;
    left: 240px;
    line-height: 50px;
}

.l5 {
    width: 400px;
    height: 50px;
    position: absolute;
    top: 432px;
    left: 240px;
    line-height: 50px;
}

.l6 {
    width: 400px;
    height: 50px;
    position: absolute;
    top: 472px;
    left: 240px;
    line-height: 50px;
}

.l7 {
    width: 324px;
    height: 50px;
    position: absolute;
    top: 562px;
    left: 572px;
    line-height: 50px;
}

.l8 {
    width: 324px;
    height: 50px;
    position: absolute;
    top: 562px;
    left: 660px;
    line-height: 50px;
}

.l9 {
    width: 324px;
    height: 50px;
    position: absolute;
    top: 562px;
    left: 720px;
    line-height: 50px;
}

.no {
    width: 324px;
    height: 50px;
    position: absolute;
    top: 238px;
    left: 590px;
    line-height: 50px;
}

#biaoge {
    background-image: url("../assets/zhengshu.png");
    background-size: 100%;
    width: 879px;
    height: 662px;
    position: relative;
    font-size: 18px;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: bolder;

}

.n1 {
    width: 150px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
}

.n2 {
    width: 330px;
    height: 50px;
    text-align: center;
    line-height: 50px;
}

.n3 {
    width: 132px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
}

.n4 {
    width: 324px;
    height: 50px;
    text-align: center;
    line-height: 50px;
}

.n5 {
    width: 790px;
    height: 200px;
    text-align: center;
    line-height: 50px;
    overflow-y: auto;
}

.n6 {
    width: 150px;
    height: 200px;
    text-align: center;
    line-height: 200px;
    font-weight: bold;
}

#u58 {
    margin-top: 40px;
    background: rgb(242, 242, 242);
    height: 120px;
    padding: 10px 0;
    font-size: 16px;
}

#u51_img {
    width: 1000px;
}

#u52_img {
    border-width: 0px;
    position: absolute;
    left: 32px;
    top: 62px;
    width: 342px;
    height: 76px;
}

.jindu {
    margin-top: 20px;
    display: flex;
    margin-left: 100px;
}

.jindu .p1 {
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background: #CCCCCC;
    color: white;
    text-align: center;
    line-height: 30px;
    margin: 0 auto;
}

.jindu .span1 {
    width: 96px;
    text-align: center;
    font-size: 14px;
    color: #CCCCCC;
}

.jindu .p2 {
    width: 30px;
    height: 30px;
    border-radius: 100px;
    background: #FF0000;
    color: white;
    text-align: center;
    line-height: 30px;
    margin: 0 auto;
}

.jindu .span2 {
    width: 96px;
    text-align: center;
    font-size: 14px;
    color: #FF0000;
}


.imgx {
    margin-left: -25px;
}

.jindu div {
    margin-left: 20px;
}

.hang {
    margin-left: 150px;
    color: black;
    font-size: 16px;
}

.inputs {
    width: 40%;
    margin-left: 10px;
}

.selects {
    width: 40%;
    margin-left: 10px;
}

.xing {
    color: red;
    font-size: 18px;
    margin-left: 5px;
}

.bei {
    font-size: 16px;
    margin-left: 30px;
    color: #c9c9c9;
}


.el-form-item label {
    color: black;
    font-size: 16px;
}

.buttons {
    cursor: pointer;
    border-width: 0px;
    width: 15%;
    height: 30px;
    background: inherit;
    background-color: rgba(255, 102, 51, 1);
    border: none;
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
    text-align: center;
}

.buttons1 {
    cursor: pointer;
    border-width: 0px;
    width: 40px;
    text-align: center;
    height: 30px;
    background: inherit;
    background-color: #409eff;
    border: none;
    border-radius: 3px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
}

.buttons2 {
    cursor: pointer;
    position: relative;
    left: 37%;
    width: 190px;
    height: 45px;
    background: inherit;
    background-color: rgba(255, 51, 51, 1);
    border: none;
    border-radius: 3px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FFFFFF;
}

.buttons3 {
    position: relative;
    left: 20%;
    width: 190px;
    height: 45px;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(255, 51, 51, 1);
    border-radius: 3px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FF3333;
}


</style>
